/* Earth Energy — embeddable buy box (variant options, one-time/subscribe toggle,
   LIVE pricing from Shopify + Recharge (first + recurring), savings, real Add to Cart).
   Inits any .ee-buybox element. Nothing hardcoded — all prices come from data-* rendered by Liquid. */
(function(){
  function money(v){ return parseFloat(String(v).replace(/[^0-9.\-]/g,'')) || 0; }
  function fmtLike(sample, value){
    var m = String(sample||'$0').match(/^([^\d\-]*)([\d.,]+)(.*)$/);
    var pre = m ? m[1] : '$', suf = m ? m[3] : '';
    return pre + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suf;
  }
  function eeBBTryDrawer(root){
    var sels=[]; var custom=root&&root.getAttribute('data-cart-selector'); if(custom) sels.push(custom);
    try{ var cd=document.querySelector('cart-drawer'); if(cd&&typeof cd.open==='function'){ cd.open(); return true; } }catch(e){}
    sels=sels.concat(['[data-cart-drawer-toggle]','[data-drawer="cart"]','button[aria-controls="CartDrawer"]','a[aria-controls="CartDrawer"]','.js-drawer-open-cart','.js-cart-trigger','.cart-drawer-toggle','[data-cart-toggle]','[data-action="open-cart"]','#cart-icon-bubble']);
    for(var i=0;i<sels.length;i++){ try{ var el=document.querySelector(sels[i]); if(el){ el.click(); return true; } }catch(e){} }
    return false;
  }
  function eeBBOpenCart(root){
    var action=(root&&root.getAttribute('data-cart-action'))||'drawer';
    if(action==='cart'||action==='page'){ window.location.href='/cart'; return; }
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      ['cart:refresh','cart:updated','cart-updated','ajaxCart:afterCartLoad','cart:build','theme:cart:reload','cart:open','cart:added','ajaxProduct:added'].forEach(function(n){ try{ document.dispatchEvent(new CustomEvent(n,{bubbles:true,detail:{cart:cart}})); }catch(e){} });
      var opened=eeBBTryDrawer(root);
      if(!opened){ window.location.href='/cart'; }
    }).catch(function(){ window.location.href='/cart'; });
  }
  function initBuyBox(root){
    if(root.dataset.bbInit === '1') return; root.dataset.bbInit = '1';
    var state = { type: 'onetime', flavor: 'unflav' };
    var options    = root.querySelectorAll('.option');
    var typeBtns   = root.querySelectorAll('[data-type]');
    var flavorBtns = root.querySelectorAll('[data-flavor]');
    var subNote    = root.querySelector('.sub-note');
    var atcButtons = root.querySelectorAll('.js-atc');

    var _ready = false;
    function ensureEls(){
      if(_ready) return; _ready = true;
      options.forEach(function(o){
        var wrap = o.querySelector('.option-price'); if(!wrap) return;
        var nowEl = wrap.querySelector('.now');
        var wasEl = wrap.querySelector('.was');
        if(!wasEl){ wasEl = document.createElement('span'); wasEl.className='was'; wasEl.style.display='none'; wrap.insertBefore(wasEl, nowEl || wrap.firstChild); }
        var perEl = wrap.querySelector('.per');
        o._orig = { wasTxt: wasEl.textContent, wasShown: wasEl.textContent.trim() !== '', perTxt: perEl ? perEl.textContent : '' };
        if(!wrap.querySelector('.js-opt-save')){ var sv=document.createElement('span'); sv.className='js-opt-save'; sv.style.cssText='display:none;font-weight:700;font-size:12px;color:#2E7D5B;margin-top:3px;white-space:nowrap'; wrap.appendChild(sv); }
        if(!wrap.querySelector('.js-opt-recur')){ var rc=document.createElement('span'); rc.className='js-opt-recur'; rc.style.cssText='display:none;font-weight:500;font-size:11px;color:#6a7a7e;margin-top:1px;white-space:nowrap'; wrap.appendChild(rc); }
      });
      if(subNote && !subNote.querySelector('.js-sub-savings')){ var ss=document.createElement('div'); ss.className='js-sub-savings'; ss.style.cssText='margin-top:6px;font-weight:700;color:#1F5C3C'; subNote.appendChild(ss); }
    }
    function renderOptions(){
      ensureEls();
      var subscribe = state.type === 'subscribe';
      options.forEach(function(o){
        var nowEl=o.querySelector('.now'), wasEl=o.querySelector('.was'), perEl=o.querySelector('.per');
        var saveEl=o.querySelector('.js-opt-save'), recEl=o.querySelector('.js-opt-recur');
        var one=o.dataset.moneyOnetime||'', sub=o.dataset.moneySub||'', recur=o.dataset.moneySubRecur||sub;
        if(subscribe && sub){
          if(nowEl) nowEl.textContent=sub;
          if(wasEl){ wasEl.textContent=one; wasEl.style.display='inline'; }
          if(perEl && o._orig.perTxt){ var ov=money(one), sv=money(sub), pv=money(o._orig.perTxt); if(ov>0) perEl.textContent=fmtLike(o._orig.perTxt, pv*sv/ov); }
          if(saveEl){ var save=money(one)-money(sub), pct=money(one)>0?Math.round(save/money(one)*100):0; if(save>0.001){ saveEl.textContent='Save '+fmtLike(one,save)+' ('+pct+'%)'; saveEl.style.display='block'; } else saveEl.style.display='none'; }
          if(recEl){ if(money(recur)>0 && Math.abs(money(recur)-money(sub))>0.009){ recEl.textContent='then '+recur+'/delivery'; recEl.style.display='block'; } else recEl.style.display='none'; }
        } else {
          if(nowEl) nowEl.textContent=one;
          if(wasEl){ if(o._orig.wasShown){ wasEl.textContent=o._orig.wasTxt; wasEl.style.display='inline'; } else wasEl.style.display='none'; }
          if(perEl) perEl.textContent=o._orig.perTxt;
          if(saveEl) saveEl.style.display='none';
          if(recEl) recEl.style.display='none';
        }
      });
    }
    function activeOption(){ return root.querySelector('.option.active') || root.querySelector('.option'); }
    function selection(){
      var opt = activeOption(); if(!opt) return null;
      var isSub = state.type === 'subscribe' && opt.dataset.moneySub;
      var variant = opt.dataset.variant || '';
      if(flavorBtns.length){ variant = (state.flavor === 'choc' ? opt.dataset.variantChoc : opt.dataset.variantUnflav) || variant; }
      return { opt:opt, variant:variant, plan:opt.dataset.plan||'', isSub:!!isSub,
        money: isSub ? opt.dataset.moneySub : opt.dataset.moneyOnetime, label: opt.dataset.label||'' };
    }
    function updateSubNote(s){
      if(!subNote) return;
      var ss = subNote.querySelector('.js-sub-savings'); if(!ss) return;
      if(s && s.isSub){
        var opt=s.opt, one=money(opt.dataset.moneyOnetime), sub=money(opt.dataset.moneySub), recur=money(opt.dataset.moneySubRecur||opt.dataset.moneySub);
        var save=one-sub, pct=one>0?Math.round(save/one*100):0;
        var txt = save>0.001 ? ('You save '+fmtLike(opt.dataset.moneyOnetime,save)+' ('+pct+'%) on your first delivery.') : '';
        if(recur>0 && Math.abs(recur-sub)>0.009){ txt += ' First delivery '+opt.dataset.moneySub+', then '+opt.dataset.moneySubRecur+' each delivery.'; }
        ss.textContent=txt; ss.style.display=txt?'block':'none';
      } else { ss.textContent=''; ss.style.display='none'; }
    }
    function render(){
      renderOptions();
      var s = selection(); if(!s) return;
      var priceLabel = s.isSub ? s.money + '/delivery' : s.money;
      atcButtons.forEach(function(btn){ var el=btn.querySelector('.atc-price'); if(el) el.textContent=priceLabel; });
      if(subNote){
        subNote.classList.toggle('show', s.isSub);
        var planEl = subNote.querySelector('.js-plan-name');
        if(planEl && s.opt.dataset.planName) planEl.textContent = s.opt.dataset.planName;
        updateSubNote(s);
      }
    }
    options.forEach(function(opt){ opt.addEventListener('click', function(){ options.forEach(function(o){o.classList.remove('active');}); opt.classList.add('active'); render(); }); });
    typeBtns.forEach(function(btn){ btn.addEventListener('click', function(){ typeBtns.forEach(function(b){b.classList.remove('active');}); btn.classList.add('active'); state.type=btn.dataset.type; render(); }); });
    flavorBtns.forEach(function(btn){ btn.addEventListener('click', function(){ flavorBtns.forEach(function(b){b.classList.remove('active');}); btn.classList.add('active'); state.flavor=btn.dataset.flavor; render(); }); });

    function addToCart(btn){
      var s = selection(); if(!s) return;
      if(!s.variant){ var o0=btn.innerHTML; btn.textContent='Added ✓ (preview)'; setTimeout(function(){ btn.innerHTML=o0; render(); },1500); return; }
      var item = { id: s.variant, quantity: 1 };
      if(s.isSub && s.plan){ item.selling_plan = s.plan; }
      var orig = btn.innerHTML; btn.disabled=true; btn.dataset.busy='1'; btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})})
        .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw e; }); } return r.json(); })
        .then(function(){ btn.textContent='Added ✓'; eeBBOpenCart(root); setTimeout(function(){ btn.disabled=false; btn.removeAttribute('data-busy'); btn.innerHTML=orig; render(); }, 1300); })
        .catch(function(err){ btn.disabled=false; btn.removeAttribute('data-busy'); btn.textContent=(err&&err.description)?err.description:(btn.dataset.cartError||'Could not add to cart.'); setTimeout(function(){ btn.innerHTML=orig; render(); },2600); });
    }
    atcButtons.forEach(function(btn){ btn.addEventListener('click', function(){ if(btn.dataset.busy!=='1') addToCart(btn); }); });
    render();
  }
  function boot(){
    document.querySelectorAll('.ee-buybox').forEach(initBuyBox);
    document.querySelectorAll('.js-scroll-buy').forEach(function(a){
      if(a.dataset.sbInit) return; a.dataset.sbInit='1';
      a.addEventListener('click', function(e){ var t=document.getElementById('ee-buy'); if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'center'}); } });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
